/** Staff roles that open the internal deal workspace at /sales/proposals/:id. */
const SALES_PROPOSAL_DEAL_WORKSPACE_ROLES = new Set(["sales", "admin", "finance"]);

export function canAccessSalesProposalDealWorkspace(role: string | undefined | null): boolean {
  return !!role && SALES_PROPOSAL_DEAL_WORKSPACE_ROLES.has(role);
}

/** Link A staff preview paths only — not bare /sales/proposals/:id (customer/public). */
export function isStaffLinkAProposalPreviewPath(pathname: string): boolean {
  const path = (pathname.split("?")[0] ?? "").replace(/\/+$/, "");
  return /^\/sales\/proposals\/\d+\/preview(?:-manual)?$/.test(path);
}
